import Axios from 'axios'
import { MIME_TYPES_TO_FILE_EXTENSION } from '@/constant/constant'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/'

Axios.defaults.headers.timeout = 8000

export default {

  // getOficioHandlingTypes (cb) {
  //   Axios.get(baseUrl + 'oficioHandlingTypes').then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  getEntityGroupItems (entitySourceTypeId, cb) {
    Axios.get(baseUrl + 'entityGroupItems?entitySourceTypeId=' + entitySourceTypeId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getGovEntities (entitySourceTypeId, cb) {
    Axios.get(baseUrl + 'govEntities?entitySourceTypeId=' + entitySourceTypeId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getOficioSigners (cb) {
    Axios.get(baseUrl + 'oficioSigners').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getAddressExamples (entitySourceTypeId, cb) {
    Axios.get(baseUrl + 'addressExamples?entitySourceTypeId=' + entitySourceTypeId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  // Deprecated
  // mailMergeOficioPDF (entityIdStr, entitySourceTypeId, instanceCode, labelTypeId, refDocNo, uploadFileId, replyDate, replyRefDocNo, cb) {
  //   let replyDateQuery = ''
  //   let replyRefDocNoQuery = ''
  //   if (replyDate) {
  //     replyDateQuery = '&replyDate=' + replyDate
  //   }
  //   if (replyRefDocNo) {
  //     replyRefDocNoQuery = '&replyRefDocNo=' + replyRefDocNo
  //   }
  //   Axios.post(baseUrl + 'mailMergeOficioPDF?entityIdStr=' + entityIdStr + '&entitySourceTypeId=' + entitySourceTypeId + '&instanceCode=' + instanceCode + '&labelTypeId=' + labelTypeId + '&refDocNo=' + refDocNo + '&uploadFileId=' + uploadFileId + replyDateQuery + replyRefDocNoQuery).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  mailMergeOficioPDF_v2 (issueEntityId, ccEntityIdStr, entityIdStr, entitySourceTypeId, instanceCode, labelTypeId, refDocNo, uploadFileId, replyDate, replyRefDocNo, mergeAttachments, cb) {
    let body = {
      carbonCopyEntityIdStr: ccEntityIdStr,
      entityIdStr: entityIdStr,
      entitySourceTypeId: entitySourceTypeId,
      instanceCode: instanceCode,
      labelTypeId: labelTypeId,
      refDocNo: refDocNo,
      replyDate: replyDate,
      replyRefDocNo: replyRefDocNo,
      uploadFileId: uploadFileId,
      mergeAttachments: mergeAttachments
    }
    if (issueEntityId) {
      body.issueEntityId = issueEntityId
    }
    return new Promise((resolve, reject) => {
      Axios.post(baseUrl + 'mailMergeOficioPDF_v2', body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  mailMergeOficioPDFByOficioId (oficioId, instanceCode, uploadFileId, cb) {
    let body = {
      oficioId: oficioId,
      instanceCode: instanceCode,
      uploadFileId: uploadFileId
    }
    Axios.post(baseUrl + 'mailMergeOficioPDF_v2', body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  // backup
  // mailMergeOficioPDFByOficioId (oficioId, instanceCode, uploadFileId, cb) {
  //   Axios.post(baseUrl + 'mailMergeOficioPDF?oficioId=' + oficioId + '&instanceCode=' + instanceCode + '&uploadFileId=' + uploadFileId).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  // Deprecated
  // insertNewOficio (data, cb) {
  //   Axios.post(baseUrl + 'insertNewOficio', data).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  insertNewOficio_v2 (data, cb) {
    Axios.post(baseUrl + 'insertNewOficio_v2', data).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  previewOficioFileList (data, cb) {
    Axios.post(baseUrl + 'previewOficioFileList', data).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  previewOficioFileListByInstanceCodes (oficioId, data, cb) {
    Axios.post(baseUrl + 'previewOficioFileListByInstanceCodes?oficioId=' + oficioId, data).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  downloadFile (cb, instanceCode, uploadFileId) {
    let uploadFileIdQuery = ''
    if (uploadFileId) {
      uploadFileIdQuery = '&uploadFileId=' + uploadFileId
    }
    Axios.get(baseUrl + 'downloadFile?instanceCode=' + instanceCode + uploadFileIdQuery, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response, MIME_TYPES_TO_FILE_EXTENSION[response.data.type])
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  // Deprecated
  // getOficioTemplate (cb) {
  //   Axios.get(baseUrl + 'getOficioTemplate').then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  getOficioTemplate_v2 (cb, businessCode, entityId) {
    let reqUrl = 'getOficioTemplate_v2'
    if (businessCode) {
      reqUrl += '?businessCode=' + businessCode
    }
    if (entityId) {
      reqUrl += '?entityId=' + entityId
    }
    Axios.get(baseUrl + reqUrl).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  oficioReceiveEntities (oficioId, cb) {
    Axios.get(baseUrl + 'oficioReceiveEntities?oficioId=' + oficioId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  oficioCarbonCopyEntities (oficioId, cb) {
    Axios.get(baseUrl + 'oficioCarbonCopyEntities?oficioId=' + oficioId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  generateRefDocNo (annual, oficioTypeId, title, cb) {
    let titleQuery = ''
    if (title) {
      titleQuery = '&title=' + title
    }
    Axios.get(baseUrl + 'generateRefDocNo?annual=' + annual + '&oficioTypeId=' + oficioTypeId + titleQuery).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  updateOficioDocuments (body, cb) {
    Axios.post(baseUrl + 'tasklist/updateOficioDocuments', body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  // updateOficioIsDirectSendToEDocX (isDirectSendToEDocX, oficioId, cb) {
  //   let body = {
  //     isDirectSendToEDocX: isDirectSendToEDocX,
  //     oficioId: oficioId
  //   }
  //   Axios.post(baseUrl + 'updateOficioIsDirectSendToEDocX', body).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  // updateOficioIsUrgent (isUrgent, oficioId, cb) {
  //   let body = {
  //     isUrgent: isUrgent,
  //     oficioId: oficioId
  //   }
  //   Axios.post(baseUrl + 'updateOficioIsUrgent', body).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       console.log(error)
  //       cb(error.response)
  //     }
  //   )
  // },

  getSignatureImage (cb) {
    Axios.get(baseUrl + 'getSignatureImage', {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'image/jpeg'
      }
    }).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  deleteSignatureImage (cb) {
    Axios.delete(baseUrl + 'deleteSignatureImage').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  administrativeSupportEntities (cb) {
    Axios.get(baseUrl + 'administrativeSupportEntities').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getIssueSubunitEntity (cb) {
    Axios.get(baseUrl + 'getIssueSubunitEntity').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getEntityAdministrativeSupportRelation (cb) {
    Axios.get(baseUrl + 'getEntityAdministrativeSupportRelation').then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  oficioEDocXStatus_v2 (oficioId, cb) {
    Axios.get(baseUrl + 'oficioEDocXStatus_v2/' + oficioId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  downloadOficioPdfZip (data, cb) {
    Axios.post(baseUrl + 'downloadOficioPdfZip', data, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getOficioById (oficioId, cb) {
    Axios.get(baseUrl + 'getOficioById?oficioId=' + oficioId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  oficioCarbonCopyOptions (oficioId, cb) {
    Axios.get(baseUrl + 'oficioCarbonCopyOptions?oficioId=' + oficioId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  callEDocXApiViaUI (approverEuid, oficioId, isUrgent, isDirectSendToEDocX, cb) {
    let body = {
      euid: approverEuid,
      formIdentity: oficioId,
      isUrgent: isUrgent,
      parameter1: isDirectSendToEDocX
    }
    Axios.post(baseUrl + 'callEDocXApiViaUI', body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getEDocXEuidListBySecurityLevelId (entityIds, securityLevelId, cb) {
    let entityQuery = ''
    entityIds.forEach(entityId => {
      entityQuery = entityQuery + '&entityIds=' + entityId
    })

    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'getEDocXEuidListBySecurityLevelId?securityLevelId=' + securityLevelId + entityQuery).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  }
}
